import { projectViewToRecord } from '~/utils/projectViews/projectViewClient';

// Fire-and-forget view for "Most viewed this week"; client-only, never blocks render, no call for guests.
export const useRecordProjectView = <T extends object>(property: MaybeRefOrGetter<T | null | undefined>) => {
  if (!import.meta.client) return;
  const authStore = useAuthStore();
  const recorded = new Set<string>();

  watch(
    () => [(toValue(property) as { complex_id?: unknown } | null | undefined)?.complex_id, authStore.token] as const,
    ([projectId, token]) => {
      const id = projectViewToRecord({
        projectId,
        token,
        role: authStore.user?.role,
        isImpersonating: authStore.getIsImpersonating,
        alreadyRecorded: recorded,
      });
      if (!id) return;
      recorded.add(id);
      $fetch('/api/projects/views', {
        method: 'POST',
        body: { projectId: id },
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => undefined);
    },
    { immediate: true },
  );
};
